import React from "react";

class Footer extends React.Component {
  render() {
    return (
      <footer className="page-footer blue-grey lighten-5">
        <div className="container" style={{ width: "80%" }}>
          <div className="row" style={{ marginBottom: "0px" }}>
            <div className="col s12 m6 l6">
              <p className="footer-left">
                © 2025 Growth Property Group LLC&nbsp;All rights reserved.
                <br />
                36 Laight Street, New York, NY 10013
                &nbsp;&nbsp;858.243.3178
              </p>
            </div>
            <div className="col s12 m6 l6 offset-2">
              <div id="footer-right">
                <a className="footer-links" href="/">Home</a>
                <span className="footer-link-divider">{" | "}</span>
                <a className="footer-links" href="/team">Team</a>
                <span className="footer-link-divider">{" | "}</span>
                <a className="footer-links" href="/acquisition-criteria">Acquisition Criteria</a>
                <span className="footer-link-divider">{" | "}</span>
                <a className="footer-links" href="/property-portfolio">Property Portfolio</a>
                <span className="footer-link-divider">{" | "}</span>
                <a className="footer-links" href="/contact">Contact</a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
